import { Companion_instance1emejao0j81tg as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  serializerodflzzf6s3fp as serializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
} from '../builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from './InlineClassDescriptor.mjs';
import {
  _ULong___get_data__impl__fggpzb3nuonax14svlz as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
  _ULong___init__impl__c78o9k2ace6d5rqjy3k as _ULong___init__impl__c78o9k,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IntCompanionObject_instance28fy14dkbnsoq as IntCompanionObject_instance,
  ByteCompanionObject_instance18rz6lk1n40xe as ByteCompanionObject_instance,
  ShortCompanionObject_instance1fu9o4qt4acxj as ShortCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  _UInt___get_data__impl__f0vqqw3lsr2hwtcnhrf as _UInt___get_data__impl__f0vqqw,
  UInt1hthisrv6cndi as UInt,
  _UInt___init__impl__l7qpdl3eewek7byy9h9 as _UInt___init__impl__l7qpdl,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UByte___get_data__impl__jof9qrfg5oujomrowy as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
  _UByte___init__impl__g9hnc418b8pq346rvu4 as _UByte___init__impl__g9hnc4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___get_data__impl__g02451ec7jdumy4xob as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
  _UShort___init__impl__jigrne3qim87o3qpsbl as _UShort___init__impl__jigrne,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ULongSerializerClass;
function ULongSerializer() {
  if (ULongSerializerClass === VOID) {
    class $ {
      constructor() {
        ULongSerializer_instance = this;
        this.r27_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer(Companion_instance));
      }
      x1m() {
        return this.r27_1;
      }
      s27(encoder, value) {
        var tmp = encoder.v1s(this.r27_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.p1s(tmp$ret$0);
      }
      y1m(encoder, value) {
        return this.s27(encoder, value instanceof ULong() ? value.xu_1 : THROW_CCE());
      }
      t27(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.l1r(this.r27_1).f1r();
        return _ULong___init__impl__c78o9k(this_0);
      }
      z1m(decoder) {
        return new (ULong())(this.t27(decoder));
      }
    }
    initMetadataForObject($, 'ULongSerializer', VOID, VOID, [KSerializer()]);
    ULongSerializerClass = $;
  }
  return ULongSerializerClass;
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new (ULongSerializer())();
  return ULongSerializer_instance;
}
var UIntSerializerClass;
function UIntSerializer() {
  if (UIntSerializerClass === VOID) {
    class $ {
      constructor() {
        UIntSerializer_instance = this;
        this.u27_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_0(IntCompanionObject_instance));
      }
      x1m() {
        return this.u27_1;
      }
      v27(encoder, value) {
        var tmp = encoder.v1s(this.u27_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.o1s(tmp$ret$0);
      }
      y1m(encoder, value) {
        return this.v27(encoder, value instanceof UInt() ? value.lu_1 : THROW_CCE());
      }
      w27(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.l1r(this.u27_1).e1r();
        return _UInt___init__impl__l7qpdl(this_0);
      }
      z1m(decoder) {
        return new (UInt())(this.w27(decoder));
      }
    }
    initMetadataForObject($, 'UIntSerializer', VOID, VOID, [KSerializer()]);
    UIntSerializerClass = $;
  }
  return UIntSerializerClass;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new (UIntSerializer())();
  return UIntSerializer_instance;
}
var UByteSerializerClass;
function UByteSerializer() {
  if (UByteSerializerClass === VOID) {
    class $ {
      constructor() {
        UByteSerializer_instance = this;
        this.x27_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_1(ByteCompanionObject_instance));
      }
      x1m() {
        return this.x27_1;
      }
      y27(encoder, value) {
        var tmp = encoder.v1s(this.x27_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.m1s(tmp$ret$0);
      }
      y1m(encoder, value) {
        return this.y27(encoder, value instanceof UByte() ? value.zt_1 : THROW_CCE());
      }
      z27(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.l1r(this.x27_1).c1r();
        return _UByte___init__impl__g9hnc4(this_0);
      }
      z1m(decoder) {
        return new (UByte())(this.z27(decoder));
      }
    }
    initMetadataForObject($, 'UByteSerializer', VOID, VOID, [KSerializer()]);
    UByteSerializerClass = $;
  }
  return UByteSerializerClass;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new (UByteSerializer())();
  return UByteSerializer_instance;
}
var UShortSerializerClass;
function UShortSerializer() {
  if (UShortSerializerClass === VOID) {
    class $ {
      constructor() {
        UShortSerializer_instance = this;
        this.a28_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_2(ShortCompanionObject_instance));
      }
      x1m() {
        return this.a28_1;
      }
      b28(encoder, value) {
        var tmp = encoder.v1s(this.a28_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.n1s(tmp$ret$0);
      }
      y1m(encoder, value) {
        return this.b28(encoder, value instanceof UShort() ? value.jv_1 : THROW_CCE());
      }
      c28(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.l1r(this.a28_1).d1r();
        return _UShort___init__impl__jigrne(this_0);
      }
      z1m(decoder) {
        return new (UShort())(this.c28(decoder));
      }
    }
    initMetadataForObject($, 'UShortSerializer', VOID, VOID, [KSerializer()]);
    UShortSerializerClass = $;
  }
  return UShortSerializerClass;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new (UShortSerializer())();
  return UShortSerializer_instance;
}
//region block: exports
export {
  UByteSerializer_getInstance as UByteSerializer_getInstance2pnfljkr2tygl,
  UIntSerializer_getInstance as UIntSerializer_getInstance3hyjif83whmd8,
  ULongSerializer_getInstance as ULongSerializer_getInstance1nf3yc5yhfc2c,
  UShortSerializer_getInstance as UShortSerializer_getInstance38i9rl5bc8983,
};
//endregion

//# sourceMappingURL=ValueClasses.mjs.map
